import React from 'react';

function Logo({ size = 'medium', className = '' }) {
  const isLarge = size === 'large';
  const iconSize = isLarge ? 48 : 38;

  return (
    <div className={`lumiflix-logo-container ${size} ${className}`} aria-label="Lumiflix">
      <div className="logo-emblem-wrap">
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="logo-svg-mark"
        >
          <defs>
            {/* Dr. Doom & Hulk Palette Gradients */}
            <linearGradient id="doomPurpleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#7e22ce" />
              <stop offset="100%" stopColor="#4c1d95" />
            </linearGradient>
            <linearGradient id="hulkGreenGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#22c55e" />
              <stop offset="100%" stopColor="#15803d" />
            </linearGradient>
            <linearGradient id="steelBorder" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#374151" />
              <stop offset="100%" stopColor="#1f2937" />
            </linearGradient>
          </defs>

          {/* Hexagonal / Armor Shield Background */}
          <path
            d="M24 3L42 12V34L24 45L6 34V12L24 3Z"
            fill="#12111d"
            stroke="url(#doomPurpleGrad)"
            strokeWidth="2.5"
            strokeLinejoin="round"
          />

          {/* Left Facet - Doom Mystic Purple */}
          <path
            d="M24 5L40 13V33L24 43V5Z"
            fill="url(#doomPurpleGrad)"
            fillOpacity="0.35"
          />

          {/* Stylized Film Strip Aperture & "L" / Play Beacon */}
          {/* Hulk Green Power Path */}
          <path
            d="M17 14V34H33"
            stroke="url(#hulkGreenGrad)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Play Triangle Inside */}
          <polygon
            points="23,20 31,25 23,30"
            fill="url(#hulkGreenGrad)"
          />

          {/* Core Power Dot */}
          <circle cx="17" cy="14" r="2.5" fill="#4ade80" />
          <circle cx="33" cy="34" r="2.5" fill="#4ade80" />
        </svg>
      </div>

      <div className="logo-text-block">
        <div className="logo-main-text">
          <span className="logo-text-lumi">LUMI</span>
          <span className="logo-text-flix">FLIX</span>
        </div>
      </div>
    </div>
  );
}

export default Logo;
